import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessSolicitudesExcepcionMora } from '../utils/gestionCampanaAccess'

const RequireSolicitudesExcepcionMoraAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessSolicitudesExcepcionMora(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireSolicitudesExcepcionMoraAccess
